import React, { useState } from 'react';
import { FaFolderOpen, FaPlus, FaTrash, FaChevronDown, FaChevronRight, FaGripVertical } from 'react-icons/fa';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import LessonBuilder from './LessonBuilder.jsx';
import './ModuleBuilder.css';

const SubmoduleBuilder = ({ submodule, onUpdate, onDelete, moduleIndex, submoduleIndex }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleTitleChange = (e) => {
    onUpdate({ ...submodule, title: e.target.value });
  };

  const handleAddLesson = () => {
    const newLesson = {
      id: `lesson-${Date.now()}-${Math.random()}`,
      title: '',
      duration: 0,
      videoUrl: '',
      type: 'video', // Required by Mongoose Schema
      order: submodule.lessons ? submodule.lessons.length : 0
    };

    onUpdate({
      ...submodule,
      lessons: [...(submodule.lessons || []), newLesson]
    });
  };

  const handleUpdateLesson = (lessonId, updatedLesson) => {
    const updatedLessons = submodule.lessons.map(lesson =>
      lesson.id === lessonId ? updatedLesson : lesson
    );
    onUpdate({ ...submodule, lessons: updatedLessons });
  };

  const handleDeleteLesson = (lessonId) => {
    const updatedLessons = submodule.lessons.filter(lesson => lesson.id !== lessonId);
    onUpdate({ ...submodule, lessons: updatedLessons });
  };

  const handleLessonDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(submodule.lessons);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Update order property
    const reorderedLessons = items.map((lesson, index) => ({
      ...lesson,
      order: index
    }));

    onUpdate({ ...submodule, lessons: reorderedLessons });
  };

  return (
    <div className="submodule-item">
      <div className="submodule-header">
        <div className="submodule-header-left">
          <FaGripVertical className="drag-handle" />
          <button
            type="button"
            className="expand-toggle"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
          </button>
          <FaFolderOpen className="submodule-icon" />
          <input
            type="text"
            value={submodule.title || ''}
            onChange={handleTitleChange}
            placeholder="Submodule title"
            className="submodule-title-input"
            required
          />
        </div>
        <div className="submodule-header-right">
          <button
            type="button"
            className="btn btn-sm btn-outline"
            onClick={handleAddLesson}
          >
            <FaPlus /> Add Lesson
          </button>
          <button
            type="button"
            className="btn-icon btn-delete"
            onClick={onDelete}
            title="Delete Submodule"
          >
            <FaTrash />
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="submodule-content">
          {submodule.lessons && submodule.lessons.length > 0 ? (
            <div className="lessons-list">
              {submodule.lessons.map((lesson, index) => (
                <LessonBuilder
                  key={lesson.id}
                  lesson={lesson}
                  index={index}
                  onUpdate={(updatedLesson) => handleUpdateLesson(lesson.id, updatedLesson)}
                  onDelete={() => handleDeleteLesson(lesson.id)}
                />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <p>No lessons yet. Click "Add Lesson" to create your first lesson.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SubmoduleBuilder;
